import { render, staticRenderFns } from "./baseFormDialog.vue?vue&type=template&id=557d36ab&scoped=true&"
import script from "./baseFormDialog.vue?vue&type=script&lang=js&"
export * from "./baseFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./baseFormDialog.vue?vue&type=style&index=0&id=557d36ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557d36ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('557d36ab')) {
      api.createRecord('557d36ab', component.options)
    } else {
      api.reload('557d36ab', component.options)
    }
    module.hot.accept("./baseFormDialog.vue?vue&type=template&id=557d36ab&scoped=true&", function () {
      api.rerender('557d36ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "meibao-insure/src/components/dialog/baseFormDialog.vue"
export default component.exports